module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/view-orders/view-orders.component.css
// module id = ./src/app/view-orders/view-orders.component.css
// module chunks = main